<template>
  <div class="page-container main">
    <el-button @click="backToList" class="back-button"></el-button>
    <el-tabs style="position: sticky;top:0;z-index: 2;background-color: #212731" v-model="activeTab">
      <el-tab-pane name="tab1">
        <span slot="label" style="margin-left: 10px;"><i class="el-icon-document"></i>&nbsp;&nbsp;订单信息</span>
      </el-tab-pane>
      <el-tab-pane name="tab2">
        <span slot="label" style="margin-left: 10px;"><i class="el-icon-coin"></i>&nbsp;&nbsp;业务信息</span>
      </el-tab-pane>
      <el-tab-pane name="tab3" v-if="false &&( isAdmin || isCaptain || isWorker)">
        <span slot="label" style="margin-left: 10px;"><i class="el-icon-chat-dot-square"></i>&nbsp;&nbsp;操作记录</span>
      </el-tab-pane>
    </el-tabs>
    <div v-show="activeTab==='tab1'">
      <el-form size="small" class="form" label-width="120px" v-loading.fullscreen.lock="loading" :element-loading-text="compress" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <!-- 原始信息-->
        <el-form-item
          v-for="item in orderTable"
          :label="item.label"
          :key="item.prop"
          :class="item.type"
          v-if="isItemVisible(item, form)"
          :required="item.editable&&item.required">
          <template v-if="isItemVisible(item, form)">
            <el-select v-if="item.editable&&item.prop==='invoice'" v-model="form[item.prop]">
              <el-option key="0" label="否" :value="0"></el-option>
              <el-option key="1" label="是" :value="1"></el-option>
            </el-select>
            <el-input v-else-if="item.filter" :readonly="true" :type="item.type || 'text'"
                      :value="item.filter(form)"></el-input>
            <template v-else-if="item.prop==='priceSum'">
              <el-input :readonly="true" :type="item.type || 'text'" :value="form[item.prop]"></el-input>
              <el-button v-if="refundShow && form.priceSum>0" size="small" type="primary" @click="dialogRefund=true">退款</el-button>
            </template>
            <el-input v-else :readonly="item.editable?!item.editable:true" :type="item.type || 'text'"
                      v-model="form[item.prop]"></el-input>
            <el-button v-if="item.prop==='publicOrderId' && isAdmin " size="small" type="default" @click="mergeOrder(form.id)">删除订单</el-button>
<!--
            <el-button v-if="item.prop==='agentPayStatus' && form.agentPayStatus==0 && isAdmin " size="small" type="default" @click="agentPay(form.id)" >扣款</el-button>
            <el-button v-if="item.prop==='agentPayStatus' && form.agentPayStatus==1 && isAdmin " size="small" type="default" @click="agentRefund(form.id)" >退预存款</el-button>
            <el-button v-if="item.prop==='agentPayStatus' && form.agentPayStatus==2 && isAdmin " size="small" type="default" @click="agentPay(form.id)" >再次扣款</el-button>
            <el-button v-if="item.prop==='agentPayStatus' && form.agentPayStatus==3 && isAdmin " size="small" type="default" @click="agentRefund(form.id)" >退代金券</el-button>
            <el-button v-if="item.prop==='agentPayStatus' && form.agentPayStatus==4 && isAdmin " size="small" type="default" @click="agentRefund(form.id)" >批准退款</el-button>
-->                        
          </template>
        </el-form-item>
        <!-- 重建类型-->
        <el-form-item label="重建类型" v-model="reconData" required>
          <div class="mockData">
            <el-table :data="reconData" border :show-header="false" style="width: 80%">
              <el-table-column label="一级" width="150">
                <template slot-scope="scope">
                  <el-checkbox
                    @change="changeCheck(scope.row.id,scope.row.level)"
                    v-model="scope.row.check" :readonly="!reconDataEditable"
                  >{{ scope.row.name + '(默认)' }}
                  </el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="二级">
                <template slot-scope="scope">
                  <el-checkbox
                    v-for="item in scope.row.children"
                    :key="item.id"
                    v-model="item.check"
                    @change="changeCheck(scope.row.id,scope.row.level)"
                    v-if="!item.ext" :readonly="!reconDataEditable"
                  >{{ item.name }}
                  </el-checkbox>
                  <div style="border-bottom: 1px dashed #ccc"></div>
                  <label class="addition">附加项目：</label>
                  <el-checkbox
                    v-for="item in scope.row.children"
                    :key="item.id"
                    v-model="item.check"
                    @change="changeCheck(scope.row.id,item.level)"
                    v-if="item.ext" :readonly="!reconDataEditable"
                  >{{ item.name }}
                    <template v-if="item.name ==='模拟肝切除'">
                      <el-input type="textarea" style="width: 350px;" :rows="1"
                                placeholder="请填写模拟切割术式，如保留肝中静脉右半肝切除"
                                v-if="item.showInput" v-model="item.inputText" clearable>
                      </el-input>
                    </template>
                  </el-checkbox>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <!-- 患者动画提取二维码-->
        <div class="qrcode" v-if="codeUrl &amp;&amp; qrcodeShow">
          <Qrcode :url="codeUrl" :patientName="form.patientName" :departmentName="form.departmentName"></Qrcode>
          <!--      <div class="text">微信扫码3D阅片</div>-->
          <el-button type="primary" size="mini" @click="saveQrImg">点击下载</el-button>
        </div>
      </el-form>
    </div>
    <div v-show="activeTab==='tab2'">
      <el-form size="small" class="form" label-width="120px" v-loading.fullscreen.lock="loading" :element-loading-text="compress" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-form-item>
          <label style="color: #9FB6E2;margin-left: -80px">患者信息</label>
          <i class="el-icon-user"/>
          <el-tag>{{this.form.patientName}}</el-tag>
          <i class="el-icon-tickets"/>
          <el-tag>{{this.form.publicOrderId}}</el-tag>
        </el-form-item>

        <div class="line"></div>
        <el-form-item>
          <label style="color: #9FB6E2;margin-left: -80px">医生信息</label>
          <i class="el-icon-school"/>
          <el-tag>{{this.form.hospitalName}}</el-tag>
          <i class="el-icon-map-location"/><el-tag>{{this.form.departmentName}}</el-tag>
          <i class="el-icon-user"/><el-tag>{{this.form.doctorName}}</el-tag>
        </el-form-item>

        <!-- 按照工序模板设置负责的人员 -->
        <el-form-item  v-if="isAdmin || isCaptain || isWorker">
          <div class="line"></div>
          <label style="color: #FFEE00;margin-left: -80px">绩点分配</label>
          <span>
            <div style="display: inline-block;margin-left: 20px;">
              <span >选择模板:</span>
              <!-- 列出所有工序模板的名字 -->
              <el-select v-model="activeActionTemplatesName" placeholder="">
                <el-option v-for="(item) in allActionTemplates" :key="item.taskType" :label="item.taskType" :value="item.taskType" />
              </el-select>
              <span>快捷分配:</span>
              <el-select placeholder="" @change="changeActionOwnerAll" :value="null" style="width: 90px">
                <el-option v-for="(item) in allWorkers" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </div>
            <div style="height: 10px;"></div>
            <div>
              <!-- 列出当前模板的工序及负责人 -->
              <span >指定人员:</span>
              <span v-if="activeActionTemplate" style="margin-left: 30px;">
                <span v-for="act in activeActionTemplate.actions" :key="act.name">
                  <i class="el-icon-user-solid"></i>
                  {{act.name}}<span style="color: #6da2f4">({{act.points}})</span>
                  <el-select placeholder="" @input="changeActionOwner" v-model="act.ownerId" style="width: 90px">
                    <el-option v-for="(item) in allWorkers" :key="item.id" :label="item.name" :value="item.id" />
                    <el-option key="无" label="无" :value="null" />
                  </el-select>
                  |
                </span>
              </span>
            </div>
          </span>
          <div/>

        </el-form-item>

        <!-- 订单标签 -->
        <el-form-item  v-if="isAdmin || isCaptain || isWorker">
          <div class="line"></div>
          <label style="color: #FF2222;margin-left: -80px">订单标签</label>
          <el-select clearable filterable placeholder="" allow-create @input="addTaskTag" value="">
            <el-option v-for="(item) in prebuiltTaskTags2" :key="item" :label="item" :value="item" />
          </el-select> |
          <span v-if="this.form.tags">
            <el-tag
              v-for="tag in this.form.tags.split('|')"
              closable
              @close="delTaskTag(tag)"
              :key="tag">
              {{tag}}
            </el-tag>
          </span>
        </el-form-item>

        <!-- 文件区 -->
        <div class="line"></div>
        <template v-if="operateShow">
          <el-form-item label="文件">
            <div :style="{display: 'flex'}">
              <FileUploader
                ref="rawUpload"
                title="原始文件"
                pathName="raw"
                :canUpload="rawUpload && (!isWorker || isMyTask)"
                :canDelete="rawDelete && (!isWorker || isMyTask)"
                :canDownload="rawDownload && (!isWorker || isMyTask)"
                :beforeDownload = 'beforeDownloadRawFile'
                @download = "downloadRawFile"
                @deleted="onRawFileDelected"
                @success="onRawFileUploaded">
              ></FileUploader>
              <FileUploader
                ref="examUpload"
                title="诊断报告及其他"
                pathName="exam_report"
                :canUpload="examUpload"
                :canDelete="examDelete"
                :canDownload="examDownload"
              ></FileUploader>
            </div>
            <div :style="{display: 'flex'}">
              <FileUploader
                v-if="stagingShow"
                ref="stagingUpload"
                title="DICOM文件"
                pathName="staging"
                bucket="dppublic"
                :uuid="form.stagingUUID"
                :canUpload="stagingUpload"
                :canDelete="stagingDelete"
                :canDownload="stagingDownload"
                uploadType="directory"
                @deleted="onStagingDelected"
                @success="onStagingSuccess">
                <template>
                  <el-button type="text" v-if="patient3dconfig" @click="dialogSetWW=true;">设置</el-button>
                </template>
                <div>
                  窗宽窗位：{{ wwOpts[currWWV].k }}
                </div>
              </FileUploader>

              <FileUploader
                v-if="rebuildingShow"
                ref="rebuildingUpload"
                title="模型文件"
                pathName="rebuilding"
                :canUpload="rebuildingUpload && (!isWorker || isMyTask)"
                :canDelete="rebuildingDelete && (!isWorker || isMyTask)"
                :canDownload="rebuildingDownload && (!isWorker || isMyTask)"
                @success="onRebuildingSuccess"
              ></FileUploader>

              <FileUploader
                v-if="archiveShow"
                ref="archiveUpload"
                title="归档文件(非必须)"
                bucket="dppublic"
                pathName="archive"
                :canUpload="archiveUpload && (!isWorker || isMyTask)"
                :canDelete="archiveDelete && (!isWorker || isMyTask)"
                :canDownload="archiveDownload && (!isWorker || isMyTask)"
                @deleted="onArchiveDelected"
                @success="onArchiveSuccess"
                :limit="3"
              ></FileUploader>
            </div>
            <div :style="{display: 'flex'}">
              <FileUploader
                v-if="doctorShow"
                ref="doctorUpload"
                :title="doctorTitle"
                bucket="dppublic"
                pathName="doctor"
                :canUpload="doctorUpload && (!isWorker || isMyTask)"
                :canDelete="doctorDelete && (!isWorker || isMyTask)"
                :canDownload="doctorDownload && (!isWorker || isMyTask)"
                @deleted="onDoctorDelected"
                @success="onDoctorSuccess"
                :limit="3"
              ></FileUploader>
              <FileUploader
                v-if="doctorShow"
                ref="viewerAppUpload"
                title="阅片软件"
                bucket="dppublic"
                pathName="viewer_app"
                :canUpload="doctorUpload && (!isWorker || isMyTask)"
                :canDelete="doctorDelete && (!isWorker || isMyTask)"
                :canDownload="doctorDownload && (!isWorker || isMyTask)"
                @deleted="onViewerAppDelected"
                @success="onViewerAppSuccess"
                :limit="3"
                :titleSlot="isAdmin || isWorker || isCaptain"
              >
                <template #title>
                  <div @click="onRequestViewerApp">
                    <i class="el-icon-connection"></i>
                  </div>
                </template>
              </FileUploader>
              <FileUploader
                v-if="patientShow"
                ref="patientUpload"
                title="患者端文件(STL)"
                bucket="dppublic"
                :uuid="form.patientUUID"
                :canUpload="patientUpload && (!isWorker || isMyTask)"
                :canDelete="patientDelete && (!isWorker || isMyTask)"
                :canDownload="patientDownload && (!isWorker || isMyTask)"
                uploadType="directory"
                @success="onPatientSuccess"
                @deleted="onPatientDelected">
                <template>
                  <el-button type="text" style="color:green" v-if="patient3dview" @click="onViewQrcode">查看</el-button>
                  <el-button type="text" v-if="patient3dconfig" @click="on3dGroup">配置</el-button>
                </template>
              </FileUploader>
              <FileUploader
                v-if="modelShow"
                ref="modelUpload"
                title="三维影像报告"
                bucket="dppublic"
                pathName="model_report"
                :canUpload="modelUpload && (!isWorker || isMyTask)"
                :canDelete="modelDelete && (!isWorker || isMyTask)"
                :canDownload="modelDownload && (!isWorker || isMyTask)"
                @success="onModeSuccess"
              ></FileUploader>
            </div>
          </el-form-item>
          <div class="line"></div>
        </template>
        <template v-if="bizTagShow">
          <el-form-item>
            <label style="color: #9FB6E2;margin-left: -80px">业务标签</label>
          </el-form-item>
          <el-form-item label="单号" key="publicOrderId2" required>
            <el-input :readonly="true" type="text" :value="this.form.publicOrderId"></el-input>
          </el-form-item>
          <el-form-item label="患者姓名" key="patientName2" required>
            <el-input :readonly="true" type="text" :value="this.form.patientName"></el-input>
          </el-form-item>
          <el-form-item label="资料完整性" key="materialIds" required>
            <el-checkbox-group v-model="materialDataChecked">
              <el-checkbox class="checkbox"
                           v-for="item in materialData"
                           :key="item.id"
                           :label="item.id"
                           @change="materialChange(item)"
              >{{ item.name }}
              </el-checkbox>
              <el-input type="textarea" autosize placeholder="请输入医生反馈" v-if="materialFeedbackShow"
                        v-model="materialFeedback" clearable>
              </el-input>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="病种" required>
            <el-select v-if="this.diseaseLevelOne" @change="diseaseLevelOneChange()" v-model="diseaseLevelOneId">
              <el-option
                v-for="item in this.diseaseLevelOne"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" key="diseaseIds" required>
            <el-checkbox-group v-model="diseaseLevelTwoDataChecked">
              <el-checkbox class="checkbox"
                           v-for="item in this.diseaseLevelTwo"
                           :label="item.id"
                           :key="item.id"
                           @change="diseaseLevelTwoChange(item)"
              >{{ item.name }}
              </el-checkbox>
              <el-input placeholder="请输入其他病种" v-if="diseaseOtherShow" v-model="diseaseOther" clearable>
              </el-input>
            </el-checkbox-group>
          </el-form-item>
        </template>
        <el-form-item v-if="notice">
          <span>{{ notice }}</span>
        </el-form-item>
        <el-form-item>
          <el-button v-if="saveShow" type="primary" @click="onSave" :disabled="isWorker && !isMyTask">保存修改</el-button>
          <el-button v-if="resolveShow" type="primary" @click="onResolve" :disabled="isWorker && !isMyTask" >开始处理</el-button>
          <el-button v-if="finishShow" type="primary" @click="onFinish" :disabled="isWorker && !isMyTask">完成订单</el-button>
          <el-button v-if="resendShow" @click="onRevert" type="danger" :disabled="isWorker && !isMyTask">医生重传</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div v-show="activeTab==='tab3'">
      <el-table stripe :data="taskActivities">
        <el-table-column prop="createTime" label="时间" width="180">
        </el-table-column>
        <el-table-column prop="operatorName" label="操作人" width="160">
        </el-table-column>
        <el-table-column prop="title" label="操作" width="200">
        </el-table-column>
        <el-table-column prop="detail" label="详情">
          <template slot-scope="scope">
            {{scope.row.content}}
            <span v-if="scope.row.content && scope.row.detail">|</span>
            {{scope.row.detail}}
          </template>
        </el-table-column>
<!--        <el-table-column label="" width="320" align="right">-->
<!--          <template slot="header" slot-scope="scope">-->
<!--            <el-button type="primary" size="small" >添加备注</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>

    <!-- 弹窗:配置显示风格-->
    <div class="stl-list">
      <el-dialog title="配置列表" :visible.sync="dialogConfigShow"
                 element-loading-spinner="el-icon-loading"
                 element-loading-background="rgba(0, 0, 0, 0.8)"
                 v-loading="loading">
        <div style="margin: 5px">
          选择展示风格 &nbsp; &nbsp;
          <el-radio-group v-model="showType" @change="showTypeChange">
            <el-radio label="0">精诊展示效果</el-radio>
            <el-radio label="-1">深总医院效果</el-radio>
            <el-radio label="-2">山东省立</el-radio>
            <el-radio label="-3">精诊模板-3</el-radio>
            <el-radio label="-4">精诊模板-4</el-radio>
          </el-radio-group>
        </div>
        <div class="btn-container">
          <el-button size="small" type="primary" @click="handleAddGroup">添加分组</el-button>
        </div>
        <el-table stripe
                  :data="stlConfigList"
                  lazy
                  :load="on3dConfig"
                  ref="stlConfigTable"
                  row-key="id"
                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">

          <el-table-column property="group" label="分组名" width="150">
            <template slot-scope="scope">
               <span v-if="scope.row.isGroup">{{ scope.row.name }}
                 <!--                <img style="width: 30px;height: 30px" :src="scope.row.url" alt="logo">-->
              </span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column property="name" label="模型名" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.isGroup">--</span>
              <span v-else>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否显示" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.show === 0 ? '否' : '是' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="不透明度">
            <template slot-scope="scope">
              <span v-if="scope.row.isGroup">--</span>
              <span
                v-else> {{
                  Number(scope.row.opacity) === 0 ? '透明' : (Number(scope.row.opacity) === 100 ? '不透明' : (scope.row.opacity + '%'))
                }}</span>
            </template>
          </el-table-column>
          <el-table-column label="颜色">
            <template slot-scope="scope">
              <span v-if="scope.row.isGroup">
                --
              </span>
              <span v-else>
                <div :style="{'background-color': 'rgb('+scope.row.color+')','width':'20px','height':'20px'}"></div>
              </span>
            </template>
          </el-table-column>
          <el-table-column property="sort" label="排序值" width="150">
          </el-table-column>
          <el-table-column label="标签">
            <template slot-scope="scope">
              <span v-if="scope.row.isGroup">
                --
              </span>
              <span v-else>
                  {{ scope.row.tag === 0 ? '轮廓' : (scope.row.tag === 1 ? '血管' : (scope.row.tag === 2 ? '病灶' : (scope.row.tag === 3 ? '切缘' : '--'))) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <template v-if="!scope.row.isGroup">
                <el-button type="text" size="small" @click="handleEdit(scope.row)"
                           slot="reference"
                           style="margin-right: 20px">编辑
                </el-button>
              </template>

              <template v-else-if="scope.row.isGroup">
                <el-button type="text" size="small" @click="handleEditGroup(scope.row)"
                           slot="reference"
                           style="margin-right: 20px">编辑
                </el-button>
                <el-popconfirm
                  title="是否删除此分组？分组下有部件时不可删除"
                  @onConfirm="handleDeleteGroup(scope.row.id)"
                >
                  <el-button type="text" size="small" slot="reference" style="margin-right: 20px">刪除</el-button>
                </el-popconfirm>
                <!--                <el-switch-->
                <!--                  v-if="scope.row.isGroup"-->
                <!--                  @change="handleSaveGroup(scope.row)"-->
                <!--                  v-model="scope.row.showStr"-->
                <!--                  active-text="显示"-->
                <!--                  inactive-text="隐藏">-->
                <!--                </el-switch>-->
              </template>

              <!--              <el-button v-if="!scope.row.isGroup" type="text" size="small" @click="handleDelete(scope.row)"-->
              <!--                         slot="reference"-->
              <!--                         style="margin-right: 20px">删除-->
              <!--              </el-button>-->

            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
    <!-- 弹窗:配置显示风格 子模块-->
    <div class="stl-add">
      <el-dialog title="编辑" :visible.sync="dialogConfigEditShow" center>
        <el-form size="small" ref="editForm" :model="editForm" :inline="true">
          <el-form-item label="模型名">
            <el-input v-model="editForm.name"></el-input>
          </el-form-item>
          <el-form-item label="选择颜色">
            <el-color-picker
              v-model="editForm.color"
              color-format="rgb"
              :predefine="predefineColors">
            </el-color-picker>
          </el-form-item>
          <!--          <el-form-item label="是否显示">-->
          <!--            <el-radio-group v-model="editForm.show">-->
          <!--              <el-radio-button :label="0">不显示</el-radio-button>-->
          <!--              <el-radio-button :label="1">显示</el-radio-button>-->
          <!--            </el-radio-group>-->
          <!--          </el-form-item>-->
          <el-form-item label="自定义不透明度">
            <el-input-number v-model="editForm.middle" :min="1" :max="99"
                             @change="editForm.middle=editForm.middle?editForm.middle:1;editForm.opacity=editForm.opacity>0&&editForm.opacity<100?editForm.middle:editForm.opacity;"
                             style="width: 50%"></el-input-number>
          </el-form-item>
          <el-form-item label="不透明度">
            <el-radio-group v-model="editForm.opacity">
              <el-radio-button :label="0">透明</el-radio-button>
              <el-radio-button :label="editForm.middle">{{ editForm.middle }}%</el-radio-button>
              <el-radio-button :label="100">不透明</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="排序值">
            <el-input-number v-model="editForm.sort" :min="1" label="1"></el-input-number>
          </el-form-item>
          <el-form-item label="选择分组">
            <el-select v-model="editForm.group" placeholder="请选择分组">
              <el-option
                v-for="item in groupData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择标签">
            <el-select v-model="editForm.tag" placeholder="请选择标签">
              <el-option
                v-for="item in tags"
                :key="item.v"
                :label="item.k"
                :value="item.v">
              </el-option>
            </el-select>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <span style="color: red" :v-if="tipShow">{{ tips }}</span>
          <br/>
          <el-button @click="dialogConfigEditShow=false">取 消</el-button>
          <el-button type="primary" @click="handleSave">保存</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 弹窗:配置显示风格 子模块-->
    <div class="group-add">
      <el-dialog :title="dialogGroupTitle" :visible.sync="dialogGroupVisible" center>
        <el-form size="small" ref="editGroupForm" :model="editGroupForm" :inline="true">
          <!--          <el-form-item label="分组名">-->
          <!--            <el-input v-model="editGroupForm.name"></el-input>-->
          <!--          </el-form-item>-->
          <el-form-item label="选择分组">
            <!--            <el-select v-model="editGroupForm.name" @change="groupSelectHandle" placeholder="请选择分组">-->
            <!--              <el-option-->
            <!--                v-for="item in groupAllData"-->
            <!--                :key="item.id"-->
            <!--                :label="item.name"-->
            <!--                :value="item.id">-->
            <!--              </el-option>-->
            <!--            </el-select>-->
            <el-autocomplete
              class="inline-input"
              v-model="editGroupForm.name"
              :fetch-suggestions="querySearchGroup"
              placeholder="请输入或选择分组"
              @select="groupSelectHandle">
              <template slot-scope="{ item }">
                <div class="name">{{ item.name }}</div>
                <!--                <span class="addr">{{ item.address }}</span>-->
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item label="排序值">
            <el-input-number v-model="editGroupForm.sort" :min="1" label="1"></el-input-number>
          </el-form-item>
          <el-form-item label="是否显示">
            <el-radio-group v-model="editGroupForm.show">
              <el-radio-button :label="0">不显示</el-radio-button>
              <el-radio-button :label="1">显示</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <!--          <el-form-item label="分组图标（120*120）" prop="url">-->
          <!--            <el-upload-->
          <!--              class="avatar-uploader"-->
          <!--              action="/api/upload/image?path=model"-->
          <!--              :show-file-list="false"-->
          <!--              :on-success="handleAvatarSuccess"-->
          <!--              :before-upload="beforeAvatarUpload">-->
          <!--              <img v-if="editGroupForm.url" :src="editGroupForm.url" class="avatar"/>-->
          <!--              <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
          <!--            </el-upload>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item v-if="groupEdit" label="默认展示体积">-->
          <!--            <el-select v-model="editGroupForm.volumeModel" placeholder="请选择默认展示体积的模型">-->
          <!--              <el-option-->
          <!--                v-for="item in groupModelList"-->
          <!--                :key="item.id"-->
          <!--                :label="item.name"-->
          <!--                :value="item.id">-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->

        </el-form>
        <div slot="footer" class="dialog-footer">
          <span style="color: red" :v-if="tipGroupShow">{{ tipsGroup }}</span>
          <br/>
          <el-button @click="dialogGroupVisible=false">取 消</el-button>
          <el-button type="primary" @click="handleSaveGroup()">保存</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 弹窗:退款操作-->
    <el-dialog title="退款" :visible.sync="dialogRefund" center width="30%">
      <el-form ref="refundForm" :model="refundForm" label-width="120px">
        <el-form-item prop="verify" label="安全密码">
          <el-input v-model="refundForm.verify" placeholder="请输入安全密码"></el-input>
        </el-form-item>
        <el-form-item prop="verify" label="退款原因">
          <el-select v-model="refundForm.remark">
            <el-option label="测试订单退款" value="测试订单退款"></el-option>
            <el-option label="患者申请退款" value="患者申请退款"></el-option>
            <el-option label="其他原因" value="其他原因"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="verify" label="退款操作人">
          <el-input v-model="refundForm.optName" placeholder="请输入退款操作人"></el-input>
        </el-form-item>
        <el-form-item label="退款金额">
          <el-input :value="form.priceSum" disabled readonly></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRefund = false">取 消</el-button>
        <el-button type="primary" @click="onRefund">退 款</el-button>
      </span>
    </el-dialog>
    <!-- 弹窗:设置Dicom窗宽窗位-->
    <el-dialog title="设置Dicom窗宽窗位" :visible.sync="dialogSetWW" center width="30%">
      <el-form ref="refundForm" :model="refundForm" label-width="120px">
        <el-form-item prop="verify" label="文件：">
          {{
            form.stagingFile ? form.stagingFile.split(',')[0] : ''
          }}等（{{ form.stagingFile ? form.stagingFile.split(',').length : 0 }}个文件）
        </el-form-item>
        <el-form-item prop="verify" label="窗宽窗位">
          <el-select v-model="currWWV" @change="currWW=wwOpts[currWWV].ww;currWC=wwOpts[currWWV].wc">
            <el-option
              v-for="item in this.wwOpts"
              :key="item.k"
              :label="item.k"
              :value="item.v">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="verify" label="ww">
          <el-input style="width: 50%" type="number" v-model="currWW"></el-input>
        </el-form-item>
        <el-form-item prop="verify" label="wc">
          <el-input style="width: 50%" type="number" v-model="currWC"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSetWW = false">取 消</el-button>
        <el-button type="primary" @click="updateWw">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 等待刷新Appviewer-->
    <el-dialog
      title="等待生成阅片程序"
      :visible.sync="waitAppViewer"
      width="30%">
      <i class="el-icon-loading" style="font-size: 24px;"></i><span>通常需要1-2分钟,可继续等待或稍后刷新页面查看</span>
      <span slot="footer" class="dialog-footer">
      <el-button @click="waitAppViewer = false">知道了</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import {mapState} from 'vuex';
import * as R from 'ramda';
import tip from '@/utils/tip';
import {refund as refundApi, stl as stlApi, task as taskApi, scorepoint, task} from '@/api';
import {TASK_STATUS} from '@/config/enum';
import {getItemsByProp, isAdmin, isAgent, isCaptain, isWorker, isDoc} from '@/utils';
import FileUploader from '@/comp/FileUploader';
import Qrcode from '@/comp/Qrcode';
import { Loading } from 'element-ui';
import {table} from './config';
import uuidv1 from 'uuid/v1';

const permission = {
  // rawShow: false,
  rawDownload: false,
  rawDelete: false,
  rawUpload: false,

  examDownload: false,
  examUpload: false,
  examDelete: false,

  stagingShow: false,
  stagingDownload: false,
  stagingDelete: false,
  stagingUpload: false,

  rebuildingShow: false,
  rebuildingUpload: false,
  rebuildingDelete: false,
  rebuildingDownload: false,

  archiveShow: false,
  archiveUpload: false,
  archiveDelete: false,
  archiveDownload: false,

  doctorShow: false,
  doctorUpload: false,
  doctorDelete: false,
  doctorDownload: false,

  patientShow: false,
  patientUpload: false,
  patientDelete: false,
  patientDownload: false,

  modelShow: false,
  modelUpload: false,
  modelDelete: false,
  modelDownload: false,

  saveShow: false,
  finishShow: false,
  resolveShow: false,
  resendShow: false,

  qrcodeShow: false,

  operateShow: true,
  bizTagShow: false,

  isMyTask: false
};

export default {
  name: 'OrderView',
  props: {},
  computed: {
    ...mapState('common', ['userInfo']),
    isDoc() {
      const {role} = this.userInfo;
      return isDoc(role);
    },
    isAgent() {
      const {role} = this.userInfo;
      return isAgent(role);
    },
    isCaptain() {
      const {role} = this.userInfo;
      return isCaptain(role);
    },
    isWorker() {
      const {role} = this.userInfo;
      return isWorker(role);
    },
    isAdmin() {
      const {role} = this.userInfo;
      return isAdmin(role);
    },
    codeUrl() {
      const {code, modelMaQr} = this.form;
      if (modelMaQr) {
        return `https://mc.truesight.com.cn/?v=2&code=${code}`;
        //return modelMaQr;
      } else if (code) {
        return `https://mc.truesight.com.cn/?v=2&code=${code}`;
      }
      return '';
    },
    doctorTitle() {
      if (this.isDoc) {
        return '三维影像数据';
      }
      return '医生端文件';
    },
  },
  data() {
    return {
      activeTab: 'tab1',
      loading: false,
      compress: '',
      notice: '',
      form: {},
      orderTable: [],
      canUpload: true,
      canDelete: true,
      params: {},
      keepCache: false,
      ...permission,
      reconData: [],
      reconDataEditable: false,
      materialData: [
        {id: 1, name: '原始数据'},
        {id: 2, name: '影像诊断报告'},
        {id: 3, name: '分期数据'},
        {id: 4, name: '预标注模型'},
        {id: 5, name: '医生端交付数据'},
        {id: 6, name: '患者端交付数据'},
        {id: 7, name: 'pdf'},
        {id: 8, name: '归档文件'},
        {id: 10, name: '重建变更'},
        {id: 9, name: '反馈'},
      ],
      materialDataChecked: [],
      materialFeedback: '',
      materialFeedbackShow: false,
      diseaseLevelOne: [],
      diseaseLevelOneId: '',
      diseaseLevelTwo: [],
      diseaseLevelTwoDataChecked: [],
      diseaseData: [],
      diseaseOther: '',
      diseaseOtherShow: false,

      patient3dview: true,
      patient3dconfig: true,
      dialogConfigShow: false,
      dialogConfigEditShow: false,
      stlConfigList: [],
      groupAllData: [],
      editForm: {
        show: 1,
        opacity: '', // 透明度字符串
        groupCopy: '',
        tag: ''
      },
      tags: [
        {k: '无', v: null},
        {k: '轮廓', v: 0},
        {k: '血管', v: 1},
        {k: '病灶', v: 2},
        {k: '切缘', v: 3}
      ],
      tipShow: false,
      groupEdit: false,
      groupData: [],
      groupModelList: [],
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        '#c58588'
      ],
      tips: '',

      editGroupForm: {
        url: '',
        show: 1,
        sort: '1',
        // volumeModel: ''
      },
      dialogGroupVisible: false,
      dialogGroupTitle: '新增',
      tipGroupShow: false,
      tipsGroup: '',
      showType: '0',

      dialogSetWW: false,
      wwOpts: [
        {k: '未设置', v: 0, ww: '--', wc: '--'},
        {k: 'MRI', v: 1, ww: '3552', wc: '1776'},
        {k: 'CT&腹部', v: 2, ww: '400', wc: '60'},
        {k: 'CT&肺窗', v: 3, ww: '1500', wc: '-400'},
        {k: 'CT&纵隔窗', v: 4, ww: '400', wc: '40'},
        {k: 'CT&血管', v: 5, ww: '600', wc: '300'},
      ],
      currWWV: 0,
      currWW: '',
      currWC: '',

      refundShow: false, // 退款
      dialogRefund: false,
      refundForm: {},

      // prebuiltTaskTags1: ['@刘宁', '@王选', '@马珊', '@张凯茹', '@刘楠楠', '@陈蓉', '@丁凯婷', '@张海彬'],
      prebuiltTaskTags2: ['加急', '付费后再做', '重要订单', '免费试用', '重要客户', '暂停', '数据有问题', '难度较大', '缺少诊断报告', '仅左侧肺', '仅右侧肺', 'AI训练可用'],

      allWorkers: [],
      allActionTemplates: [],
      activeActionTemplatesName: '',
      activeActionTemplate: null,
      waitAppViewer: false,
      taskActivities: [] // 订单活动记录
    };
  },
  components: {
    FileUploader,
    Qrcode,
  },
  methods: {
    downloadRawFile(filename) {
      if (this.resolveShow) {
        this.$confirm(`开始处理?`, '提示', {}).then(() => {
          this.onResolve();
        });
      }
    },
    beforeDownloadRawFile(filename) {
      return new Promise((resolve, reject) => {
        resolve();
        /*
        this.$confirm('启动建模工具?', '提示', {
          confirmButtonText: '启动工具',
          cancelButtonText: '普通下载',
          type: 'warning'
        }).then(() => {
          window.open('buildmodeltools://' + this.form.publicOrderId, '_blank');
          reject(new Error('use model tool!'));
        }).catch(() => {
          resolve();
        }); */
      });
    },
    backToList() {
      this.keepCache = true;
      this.$router.back();
    },
    isItemVisible(row, form) {
      const {visible} = row;
      if (R.is(Function, visible)) {
        form['isAdmin'] = this.isAdmin;
        form['isCaptain'] = this.isCaptain;
        form['isWorker'] = this.isWorker;
        return visible(form);
      }
      return true;
    },
    async onCreated() {
      const {id} = this.$route.params;
      if (id) {
        this.params = {
          ...this.$route.params,
          id: Number(this.$route.params.id),
        };
        const data = await taskApi.fetchById(id);
        if (data.code === 10000) {
          this.form = data.data;
          const {
            rawFile, examReportFile, stagingFile,
            // patientFile,
            rebuildingFile, archiveFile, doctorFile, viewerAppFile, patientFileUrl, modelReportFile
          } = this.form;
          this.setOrderTable();
          this.$nextTick(() => {
            const {
              rawUpload, examUpload, stagingUpload, rebuildingUpload,
              archiveUpload, doctorUpload, viewerAppUpload, patientUpload, modelUpload
            } = this.$refs;

            if (rawUpload && rawFile) {
              rawUpload.setFile({paths: [rawFile]});
            }
            if (examUpload && examReportFile) {
              examUpload.setFile({paths: examReportFile});
            }
            if (stagingUpload && stagingFile) {
              const fileArr = stagingFile.split(',');
              stagingUpload.setFile({paths: [fileArr[0] + ' 等' + (fileArr.length) + '个文件']});
            }
            if (rebuildingUpload) {
              rebuildingUpload.setFile({paths: [rebuildingFile]});
            }
            if (archiveUpload) {
              archiveUpload.setFile({paths: archiveFile});
            }
            if (doctorUpload) {
              doctorUpload.setFile({paths: doctorFile});
            }
            if (viewerAppFile) {
              viewerAppUpload.setFile({paths: viewerAppFile});
            }
            if (patientUpload) {
              patientUpload.setFile({paths: [patientFileUrl]});
            }
            if (modelUpload) {
              modelUpload.setFile({paths: [modelReportFile]});
            }
          });

          if (this.form.ww && this.form.ww.split(',')[0]) {
            this.currWWV = Number(this.form.ww.split(',')[0]);
            this.currWW = this.form.ww.split(',')[1];
            this.currWC = this.form.ww.split(',')[2];
          }

          this.loadMaterialData();

          this.loadReconData();
          this.loadDiseaseData();
          this.queryGroup();
        }
      }
    },
    setOrderTable() {
      R.pipe(
        R.keys,
        R.forEach(key => {
          this[key] = permission[key];
        }),
      )(permission);

      const {status} = this.form;
      switch (status) {
        case TASK_STATUS.UNSUBMIT:
          this.orderTable = getItemsByProp([
            'examPatientId', 'hospitalName', 'departmentName', 
            'patientPhone', 'patientNote', /* 'itemNames', */
          ], table);
          // this.operateShow = false;
          // 管理员
          if (this.isAdmin) {
            this.refundShow = true;
            // 原始文件 上传、删除、下载
            this.rawUpload = true;
            this.rawDelete = true;
            this.rawDownload = true;
            // 诊断报告 上传、删除、下载
            this.examUpload = true;
            this.examDelete = true;
            this.examDownload = true;
            // 分期文件  /
            this.stagingShow = false;
            // 模型文件 /
            this.rebuildingShow = false;
            // 医生端文件 /
            this.doctorShow = false;
            // 患者端文件 /
            this.patientShow = false;
            // 三维影像报告 /
            this.modelUpload = false;
            // 归档文件 /
            this.archiveShow = false;
            // 组长
          } else if (this.isCaptain) {
            // 原始文件 上传、删除、下载
            this.rawUpload = true;
            this.rawDelete = true;
            this.rawDownload = true;
            // 诊断报告 上传、删除、下载
            this.examUpload = true;
            this.examDelete = true;
            this.examDownload = true;
            // 分期文件  /
            this.stagingShow = false;
            // 模型文件 /
            this.rebuildingShow = false;
            // 医生端文件 /
            this.doctorShow = false;
            // 患者端文件 /
            this.patientShow = false;
            // 三维影像报告 /
            this.modelUpload = false;
            // 归档文件 /
            this.archiveShow = false;
          } else if (this.isDoc || this.isAgent) {
            // 原始文件 上传、删除、下载
            this.rawUpload = true;
            this.rawDelete = true;
            this.rawDownload = true;
            // 诊断报告 上传、删除、下载
            this.examUpload = true;
            this.examDelete = true;
            this.examDownload = true;
            // 分期文件  /
            this.stagingShow = false;
            // 模型文件 /
            this.rebuildingShow = false;
            // 医生端文件 /
            this.doctorShow = false;
            // 患者端文件 /
            this.patientShow = false;
            // 三维影像报告 /
            this.modelUpload = false;
            // 归档文件 /
            this.archiveShow = false;
          }

          // 操作按钮
          this.saveShow = false;
          this.resolveShow = false;
          this.finishShow = false;
          this.resendShow = false;
          this.bizTagShow = false;
          this.qrcodeShow = false;

          break;
        case TASK_STATUS.SUBMITED:
          this.orderTable = table;
          if (!this.isAdmin) {
            if (this.isCaptain || this.isWorker) {
              // 原始文件 上传、删除、下载
              this.rawUpload = true;
              this.rawDelete = true;
              this.rawDownload = true;
              // 诊断报告 上传、删除、下载
              this.examUpload = false;
              this.examDelete = false;
              this.examDownload = true;
              // 分期文件  /
              this.stagingShow = false;
              // this.stagingUpload = true;
              // this.stagingDelete = true;
              // this.stagingDownload = true;
              // 模型文件 /
              this.rebuildingShow = true;
              this.rebuildingUpload = true;
              this.rebuildingDelete = true;
              this.rebuildingDownload = true;
              // 医生端文件 /
              this.doctorShow = false;
              // 患者端文件 /
              this.patientShow = false;
              // 三维影像报告 /
              this.modelShow = false;
              // 归档文件 /
              this.archiveShow = false;
              // 操作按钮
              this.saveShow = true;
              this.resolveShow = true;
              this.resendShow = true;
            } else if (this.isDoc || this.isAgent) {
              // 原始文件 上传、删除、下载
              this.rawUpload = false;
              this.rawDelete = false;
              this.rawDownload = true;
              // 诊断报告 上传、删除、下载
              this.examUpload = false;
              this.examDelete = false;
              this.examDownload = true;
              // 分期文件  /
              this.stagingShow = false;
              // 模型文件 /
              this.rebuildingShow = false;
              // 医生端文件 /
              this.doctorShow = false;
              // 患者端文件 /
              this.patientShow = false;
              // 三维影像报告 /
              this.modelShow = false;
              // 归档文件 /
              this.archiveShow = false;
            }
          } else {
            // 指定某些字段可编辑
            this.orderTable.forEach(item => {
              // eslint-disable-next-line no-unused-expressions
              item.prop === 'doctorName' ? (item['editable'] = true) : '';
              // eslint-disable-next-line no-unused-expressions
              item.prop === 'doctorPhone' ? (item['editable'] = true) : '';
              // eslint-disable-next-line no-unused-expressions
              // item.prop === 'email' ? (item['editable'] = true) : '';
              // eslint-disable-next-line no-unused-expressions
              item.prop === 'patientName' ? (item['editable'] = true) : '';
              // eslint-disable-next-line no-unused-expressions
              item.prop === 'examPatientId' ? (item['editable'] = true) : '';
              // eslint-disable-next-line no-unused-expressions
              item.prop === 'patientPhone' ? (item['editable'] = true) : '';
              // eslint-disable-next-line no-unused-expressions
              item.prop === 'patientNote' ? (item['editable'] = true) : '';
              // eslint-disable-next-line no-unused-expressions
              item.prop === 'note' ? (item['editable'] = true) : '';
              // eslint-disable-next-line no-unused-expressions
              // item.prop === 'invoice' ? (item['editable'] = true) : '';
              // eslint-disable-next-line no-unused-expressions
              // item.prop === 'invoiceAddr' ? (item['editable'] = true) : '';
              // eslint-disable-next-line no-unused-expressions
              // item.prop === 'processor' ? (item['editable'] = true) : '';
            });
            this.reconDataEdit = true;
            this.refundShow = true;
            // 原始文件 上传、删除、下载
            this.rawUpload = true;
            this.rawDelete = true;
            this.rawDownload = true;
            // 诊断报告 上传、删除、下载
            this.examUpload = true;
            this.examDelete = true;
            this.examDownload = true;
            // 分期文件  /
            this.stagingShow = false;
            // this.stagingUpload = true;
            // this.stagingDelete = true;
            // this.stagingDownload = true;
            // 模型文件 /
            this.rebuildingShow = true;
            this.rebuildingUpload = true;
            this.rebuildingDelete = true;
            this.rebuildingDownload = true;
            // 医生端文件 /
            this.doctorShow = false;
            // 患者端文件 /
            this.patientShow = false;
            // 三维影像报告 /
            this.modelShow = false;
            // 归档文件 /
            this.archiveShow = false;
            // 操作按钮
            this.saveShow = true;
            this.resolveShow = true;
            this.resendShow = true;

            // 组长
          }
          // isDoc
          if (this.isDoc) {
            this.orderTable = getItemsByProp([
              'publicOrderId', 'submitTime', 'hospitalName', 'departmentName', 
              'doctorName', 'doctorPhone', 'patientName', 'examPatientId',
              'patientPhone', 'patientNote', 'note',
            ], table);
          }
          // notice
          if (this.isDoc || this.isAgent) {
            this.notice = '如需修改<已提交>订单，请联系您的对接人员';
          }
          break;
        case TASK_STATUS.PROCESSING:
          // this.orderTable = getItemsByProp([
          //   'publicOrderId', 'submitTime', 'hospitalName', 'departmentName', 'invoiceAddr',
          //   'doctorName', 'doctorPhone', 'patientName', 'examPatientId',
          //   'patientPhone', 'patientNote', 'note',
          // ], table);
          this.orderTable = table;

          if (this.isAdmin) {
            // this.orderTable.forEach(item => {
            //   if (item.prop === 'processor') {
            //     item.visible = () => false;
            //   }
            // });
            // 原始文件 上传、删除、下载
            this.refundShow = true;
            this.rawUpload = true;
            this.rawDelete = true;
            this.rawDownload = true;
            // 诊断报告 上传、删除、下载
            this.examUpload = false;
            this.examDelete = false;
            this.examDownload = true;
            // 分期文件  /
            this.stagingShow = true;
            this.stagingUpload = true;
            this.stagingDelete = true;
            this.stagingDownload = true;
            // 模型文件 /
            this.rebuildingShow = true;
            this.rebuildingUpload = true;
            this.rebuildingDelete = true;
            this.rebuildingDownload = true;
            // 医生端文件 /
            this.doctorShow = true;
            this.doctorUpload = true;
            this.doctorDelete = true;
            this.doctorDownload = true;
            // 患者端文件 /
            this.patientShow = true;
            this.patientUpload = true;
            this.patientDelete = true;
            this.patientDownload = true;
            // 三维影像报告 /
            this.modelShow = true;
            this.modelUpload = true;
            this.modelDelete = true;
            this.modelDownload = true;
            // 归档文件 /
            this.archiveShow = true;
            this.archiveUpload = true;
            this.archiveDelete = true;
            this.archiveDownload = true;
            // 操作按钮
            this.saveShow = true;
            this.finishShow = true;
            this.resendShow = true;
            this.bizTagShow = true;

            this.qrcodeShow = true;
            // 组长
          } else if (this.isCaptain || this.isWorker) {
            // 原始文件 上传、删除、下载
            this.rawUpload = this.isCaptain;
            this.rawDelete = this.isCaptain;
            this.rawDownload = true;
            // 诊断报告 上传、删除、下载
            this.examUpload = false;
            this.examDelete = false;
            this.examDownload = true;
            // 分期文件  /
            this.stagingShow = true;
            this.stagingUpload = true;
            this.stagingDelete = true;
            this.stagingDownload = true;
            // 模型文件 /
            this.rebuildingShow = true;
            this.rebuildingUpload = true;
            this.rebuildingDelete = true;
            this.rebuildingDownload = true;
            // 医生端文件 /
            this.doctorShow = true;
            this.doctorUpload = true;
            this.doctorDelete = true;
            this.doctorDownload = true;
            // 患者端文件 /
            this.patientShow = true;
            this.patientUpload = true;
            this.patientDelete = true;
            this.patientDownload = true;
            // 三维影像报告 /
            this.modelShow = true;
            this.modelUpload = true;
            this.modelDelete = true;
            this.modelDownload = true;
            // 归档文件 /
            this.archiveShow = true;
            this.archiveUpload = true;
            this.archiveDelete = true;
            this.archiveDownload = true;
            // 操作按钮
            this.saveShow = true;
            this.finishShow = true;
            this.resendShow = true;
            this.bizTagShow = true;

            this.qrcodeShow = true;
          } else if (this.isDoc || this.isAgent) {
            // 原始文件 上传、删除、下载
            this.rawUpload = false;
            this.rawDelete = false;
            this.rawDownload = true;
            // 诊断报告 上传、删除、下载
            this.examUpload = false;
            this.examDelete = false;
            this.examDownload = true;
            // 分期文件  /
            this.stagingShow = false;
            // 模型文件 /
            this.rebuildingShow = false;
            // 医生端文件 /
            this.doctorShow = false;
            // 患者端文件 /
            this.patientShow = false;
            // 三维影像报告 /
            this.modelShow = false;
            // 归档文件 /
            this.archiveShow = false;
            // 操作按钮
            this.saveShow = false;
            this.finishShow = true;
            this.resolveShow = false;
            this.resendShow = true;
            this.qrcodeShow = false;
            // 查看3d模型
            this.patient3dview = false;
            this.patient3dconfig = false;
          }
          // 代理商 操作按钮
          if (this.isAgent) {
            // 操作按钮
            this.saveShow = false;
            this.finishShow = false;
            this.resolveShow = false;
            this.resendShow = false;
            this.qrcodeShow = false;
          }

          // notice
          if (this.isDoc || this.isAgent) {
            this.notice = '如需修改<已提交>订单，请联系您的对接人员';
          }
          break;
        case TASK_STATUS.FINISHED:
          this.orderTable = table;
          // 管理员
          if (this.isAdmin) {
            // this.orderTable.forEach(item => {
            //   if (item.prop === 'processor') {
            //     item.visible = () => false;
            //   }
            // });
            // 原始文件 上传、删除、下载
            this.refundShow = true;
            this.rawUpload = false;
            this.rawDelete = false;
            this.rawDownload = true;
            // 诊断报告 上传、删除、下载
            this.examUpload = false;
            this.examDelete = false;
            this.examDownload = true;
            // 分期文件  /
            this.stagingShow = true;
            this.stagingUpload = true;
            this.stagingDelete = true;
            this.stagingDownload = true;
            // 模型文件 /
            this.rebuildingShow = true;
            this.rebuildingUpload = true;
            this.rebuildingDelete = true;
            this.rebuildingDownload = true;

            // 医生端文件 /
            this.doctorShow = true;
            this.doctorUpload = true;
            this.doctorDelete = true;
            this.doctorDownload = true;
            // 患者端文件 /
            this.patientShow = true;
            this.patientUpload = true;
            this.patientDelete = true;
            this.patientDownload = true;
            // 三维影像报告 /
            this.modelShow = true;
            this.modelUpload = true;
            this.modelDelete = true;
            this.modelDownload = true;
            // 归档文件 /
            this.archiveShow = true;
            this.archiveUpload = true;
            this.archiveDelete = true;
            this.archiveDownload = true;
            // 操作按钮
            this.saveShow = true;
            this.qrcodeShow = true;
            this.bizTagShow = true;
            // 组长
          } else if (this.isCaptain || this.isWorker) {
            // 原始文件 上传、删除、下载
            this.rawUpload = false;
            this.rawDelete = false;
            this.rawDownload = true;
            // 诊断报告 上传、删除、下载
            this.examUpload = false;
            this.examDelete = false;
            this.examDownload = true;
            // 分期文件  /
            this.stagingShow = true;
            this.stagingUpload = true;
            this.stagingDelete = true;
            this.stagingDownload = true;
            // 模型文件 /
            this.rebuildingShow = true;
            this.rebuildingUpload = false;
            this.rebuildingDelete = false;
            this.rebuildingDownload = true;
            // 医生端文件 /
            this.doctorShow = true;
            this.doctorUpload = true;
            this.doctorDelete = true;
            this.doctorDownload = true;
            // 患者端文件 /
            this.patientShow = true;
            this.patientUpload = true;
            this.patientDelete = true;
            this.patientDownload = true;
            // 三维影像报告 /
            this.modelShow = true;
            this.modelUpload = true;
            this.modelDelete = true;
            this.modelDownload = true;
            // 归档文件 /
            this.archiveShow = true;
            this.archiveUpload = true;
            this.archiveDelete = true;
            this.archiveDownload = true;
            // 操作按钮
            this.saveShow = true;
            this.qrcodeShow = true;
            this.bizTagShow = true;
            // 医生 代理商
          } else if (this.isDoc || this.isAgent) {
            // 原始文件 上传、删除、下载
            this.rawUpload = false;
            this.rawDelete = false;
            this.rawDownload = true;
            // 诊断报告 上传、删除、下载
            this.examUpload = false;
            this.examDelete = false;
            this.examDownload = true;
            // 分期文件  /
            this.stagingShow = false;
            // 模型文件 /
            this.rebuildingShow = false;
            // 医生端文件 /
            this.doctorShow = true;
            this.doctorUpload = false;
            this.doctorDelete = false;
            this.doctorDownload = true;
            // 患者端文件 /
            this.patientShow = this.isDoc;
            // 三维影像报告 /
            this.modelShow = true;
            this.modelUpload = false;
            this.modelDelete = false;
            this.modelDownload = true;
            // 归档文件 /
            this.archiveShow = false;
            // 操作按钮
            this.qrcodeShow = true;
            // 查看3d模型
            this.patient3dview = this.isDoc;
            this.patient3dconfig = false;
          }
          if (this.isAgent || this.isDoc) {
            this.notice = '注：如对重建结果有疑问，请联系您的对接人员';
            if (this.isDoc) {
              this.orderTable = getItemsByProp([
                'publicOrderId', 'submitTime', 'processFinishTime', 'code', 'hospitalName', 'departmentName',
                'doctorName', 'doctorPhone', 'patientName', 'examPatientId',
                'patientPhone', 'patientNote', 'note',
              ], table);
            }
          }
          break;
        default:
          break;
      }
    },
    async onResolve() {
      const {id} = this.params;
      const data = await taskApi.processStart(id);
      if (data.code === 10000) {
        tip.success('订单已进入处理中!');
        this.onCreated();
      }
    },
    async finish() {
      const {id} = this.params;
      const {archiveFile, doctorFile, modelReportFile} = this.form;
      if (id) {
        const params = {id, archiveFile, doctorFile, modelReportFile};

        const data = await taskApi.processFinish(params);
        if (data.code === 10000) {
          tip.success('保存成功');
          if (this.isDoc) {
            this.$router.push({
              name: 'fetchFinished',
            });
          } else {
            this.$router.push({
              name: 'fetchFinishedInner',
            });
          }
        }
      }
    },
    async onFinish() {
      const {archiveFile, doctorFile, modelReportFile, patientFile} = this.form;
      if (!archiveFile) {
        tip.error('归档文件必填');
        return;
      }
      if (!doctorFile) {
        tip.error('医生端文件必填');
        return;
      }
      if (!patientFile || !modelReportFile) {
        let textList = [];
        if (!patientFile) {
          textList.push('患者端文件');
        }
        if (!modelReportFile) {
          textList.push('三维影像报告');
        }
        this.$message.error(`${R.join(',', textList)}还未上传，请先上传在进行操作`);

        // this.$confirm(`${R.join(',', textList)}还未上传，是否要完成订单`).then(() => {
        //   this.finish();
        // });
      } else {
        this.finish();
      }
    },
    async onSave() {
      // 处理重建类型
      let selectedRecon = '';
      this.reconData.forEach(item => {
        // 先处理一级
        if (item.check) {
          selectedRecon += item.id + ',';
        }
        // 再处理二级
        item.children.forEach(child => {
          if (child.check) {
            if (child.inputText) {
              selectedRecon += child.id + ':' + child.inputText + ',';
            } else {
              selectedRecon += child.id + ',';
            }
          }
        });
      });
      if (this.reconDataEditable && selectedRecon.length <= 0) {
        tip.error('请选择重建类型！');
        return;
      }
      this.form['reconIds'] = selectedRecon;
      // 处理 资料完整性
      let selectedMaterial = '';
      this.materialDataChecked.forEach(item => {
        // 反馈
        if (item === 9) {
          selectedMaterial += item + ':' + this.materialFeedback + ',';
        } else {
          selectedMaterial += item + ',';
        }
      });
      this.form['materialIds'] = selectedMaterial;
      // 处理 病种
      let selectedDisease = '';
      if (this.diseaseLevelOneId) {
        selectedDisease += this.diseaseLevelOneId + ',';
      }
      this.diseaseLevelTwoDataChecked.forEach(item => {
        if (item % 100 === 99) {
          if (this.diseaseOther) {
            // tip.error('请输入其他病种');
            selectedDisease += item + ':' + this.diseaseOther + ',';
          }
        } else if (item) {
          selectedDisease += item + ',';
        }
      });
      this.form['diseaseIds'] = selectedDisease;

      const data = await taskApi.processEdit(this.form) || {};
      if (data.code === 10000) {
        tip.success('保存成功');
      }
    },
    async onRevert() {
      const {id} = this.params;
      this.$confirm('确认重传？').then(() => {
        taskApi.processRevert(id).then(res => {
          if (res.code === 10000) {
            tip.success('订单已重传');
            if (this.isAdmin) {
              this.$router.push({
                name: 'OrderProcessingInner',
              });
            } else {
              this.$router.push({
                name: 'OrderProcessing',
              });
            }
          }
        });
      });
    },
    // 打开模型
    onViewQrcode() {
      const {code} = this.form;
      if (code) {
        const stlUrl = `https://mc.truesight.com.cn/?v=2&code=` + code;
        window.open(stlUrl, '_blank');
      }
    },
    // 请求重新生成ViewerApp
    onRequestViewerApp() {
      const {id} = this.params;
      this.$confirm('重新生成阅片软件？').then(() => {
        taskApi.queryViewerApp(id).then(res => {
          if (res.code === 10000) {
            this.waitForAppViewer();
          }
        });
      });
    },
    /**
     * 分组新增
     */
    handleAddGroup() {
      this.dialogGroupVisible = true;
      this.dialogGroupTitle = '新增';
      this.groupEdit = false;
      this.editGroupForm = {
        url: '',
        show: 1,
        sort: '1'
      };
    },
    // handleAvatarSuccess(res) {
    //   this.editGroupForm.url = res.data;
    // },
    // beforeAvatarUpload(file) {
    //   const isLt2M = file.size / 1024 / 1024 < 2;
    //
    //   if (!isLt2M) {
    //     this.$message.error('上传图片大小不能超过 2MB!');
    //   }
    //   return isLt2M;
    // },
    handleEditGroup(row) {
      this.on3dConfig(row);
      // this.editGroupForm.volumeModel = row.volumeModel;
      this.dialogGroupVisible = true;
      this.dialogGroupTitle = '编辑';
      this.groupEdit = true;
      this.editGroupForm = row;
      this.editGroupForm.show = row.show;
    },
    handleDeleteGroup(id) {
      stlApi.deleteGroup(id, this.form.orderId)
        .then((res) => {
          if (res.code === 10000) {
            this.$message.success('删除成功！');
            this.on3dGroup();
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    async handleSaveGroup(row) {
      let data = row || this.editGroupForm;
      data.orderId = this.form.orderId;
      // 有id 修改
      if (data.id) {
        data = await stlApi.updateGroup(data);
      } else {
        // 没id 新增
        data = await stlApi.addGroup(data);
        if (!data) return;
      }
      if (data.code === 10000) {
        this.$message.success('成功！');
        this.on3dGroup();
      } else {
        this.$message.error(data.msg);
      }
    },
    // 加载库里全部的分组
    async queryGroup() {
      const submitForm = {orderId: 0};
      const res = await stlApi.listGroup(submitForm);
      if (res.code === 10000) {
        const {data} = res;
        this.groupAllData = data;
      }
    },
    // 输入框输入后 自动过滤候选项
    querySearchGroup(queryString, cb) {
      var restaurants = this.groupAllData;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    /**
     * 更新窗宽窗位
     */
    async updateWw() {
      let data = await taskApi.updateWW({id: this.form.id, ww: `${this.currWWV},${this.currWW},${this.currWC}`});
      if (data.code === 10000) {
        this.$message.success('保存成功！');
      }
      this.dialogSetWW = false;
    },

    // 添加分组 的选择
    groupSelectHandle(item) {
      const group = this.groupAllData.filter(d => d.id === item.id)[0];
      if (group) {
        this.editGroupForm.sort = group.sort;
        this.editGroupForm.show = group.show;
        this.editGroupForm.url = group.url;
        this.editGroupForm.name = group.name;
      }
    },

    /**
     * 加载模型分组
     */
    async on3dGroup() {
      const submitForm = {orderId: this.form.orderId};
      const res = await stlApi.listGroup(submitForm);
      if (res.code === 10000) {
        const {data} = res;
        this.groupData = [];
        data.forEach(e => {
          this.groupData.push({
            id: e.id,
            name: e.name
          });
          // e.key = uuidv1();
          e.isGroup = true;
          e.hasChildren = true;
          e.showStr = e.show !== 0;
        });
        console.log(data);
        this.showType = data[0].tmpOrderId ? data[0].tmpOrderId.toString() : '0';
        this.stlConfigList = data;
        this.dialogConfigShow = true;
      }
    },
    /**
     * 加载模型
     */
    async on3dConfig(row, treeNode, resolve) {
      let params = {
        code: this.form.code,
        group: row.id
      };
      const res = await stlApi.code(params);
      if (res.code === 10000) {
        const {data} = res;
        data.forEach(e => {
          e.visible = false;
          e.color = e.color.split(',')[0] + ',' + e.color.split(',')[1] + ',' + e.color.split(',')[2];
          e.key = uuidv1();
          e.isGroup = false;
          e.hasChildren = false;
          // e.opacity = Number(e.opacity) === 0 ? 0 : (Number(e.opacity) === 100 ? 100 : 50);
        });
        if (row) {
          this.groupModelList = data;
          if (resolve) {
            resolve([
              ...data
            ]);
          }
        }
        // this.stlConfigList = data;
      }
    },
    // dialog 点击保存
    async handleSave() {
      if (!this.editForm.name) {
        this.tipShow = true;
        this.tips = '模型名不能为空';
        return;
      }
      if (!this.editForm.color) {
        this.tipShow = true;
        this.tips = '颜色不能为空';
        return;
      }
      this.tipShow = false;
      this.tips = '';
      this.editForm.color = this.editForm.color.replace('rgb(', '').replace(')', '').replace(' ', '').replace(' ', '');
      let data;
      // 有id 修改
      if (this.editForm.id) {
        data = await stlApi.update(this.editForm);
      }
      if (data.code === 10000) {
        this.$message.success('成功！');
        // 如果更改了分组 则需要刷新页面
        if (this.editForm.group !== this.editForm.groupCopy) {
          const that = this;
          that.$set(that.$refs.stlConfigTable.store.states.lazyTreeNodeMap, that.editForm.group, []);
          let resolveOld = function(data) {
            that.$set(that.$refs.stlConfigTable.store.states.lazyTreeNodeMap, that.editForm.group, data);
          };
          this.on3dConfig({id: this.editForm.group}, null, resolveOld);

          that.$set(that.$refs.stlConfigTable.store.states.lazyTreeNodeMap, that.editForm.groupCopy, []);
          let resolveNew = function(data) {
            that.$set(that.$refs.stlConfigTable.store.states.lazyTreeNodeMap, that.editForm.groupCopy, data);
          };
          this.on3dConfig({id: this.editForm.groupCopy}, null, resolveNew);
        }
      } else {
        this.tipShow = true;
        this.tips = data.msg;
      }
    },
    // list 点击编辑
    async handleEdit(row) {
      this.dialogConfigEditShow = true;
      const data = row;
      if (!data) return;
      this.editForm = data;
      this.editForm.groupCopy = data.group;

      this.editForm.color = `rgb(${this.editForm.color})`;
    },
    // 显示类型切换
    async showTypeChange(val) {
      this.$confirm('此操作将清除当前视图下模型配置并切换，是否继续切换', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        this.showType = val;
        this.loading = true;
        const res = await stlApi.changeTmp({orderId: this.form.orderId, tmpOrderId: this.showType});
        if (res.code === 10000) {
          this.on3dGroup();
        }
        this.loading = false;
      }).catch(() => {
        this.showType = this.stlConfigList[0] ? this.stlConfigList[0].tmpOrderId.toString() : '0';
      });
    },

    async handleDelete(row) {
      this.$confirm(`确认删除${row.name}?`, '提示', {}).then(() => {
        stlApi.delete(this.editForm).then(res => {
          if (res.code === 10000) {
            this.$message.success('成功！');
          }
        });
      }).catch(console.log);
    },
    // 当原始文件被删除时调用
    async onRawFileDelected({path}) {
      const {id} = this.params;
      this.form.rawFile = null;
      taskApi.removeCreateFile({id, rawFile: path});
    },
    // 当原始上传时调用
    async onRawFileUploaded({paths}) {
      this.form.rawFile = paths[0];
      this.$message.success('上传成功,请点击保存');
    },
    // 分期文件
    async onStagingDelected() {
      const {id} = this.params;
      const data = await taskApi.removeProcessFile({id, stagingFile: this.form.stagingFile});
      if (data.code === 10000) {
        tip.success('删除成功');
      }
    },
    onStagingSuccess({dir, paths}) {
      // const path = R.head(paths);
      const {id} = this.params;
      this.form.stagingFile = paths[0] + ' 等' + (paths.length) + '个文件';
      this.compress = '后台压缩中 0%';
      this.loading = true;

      let curr = 0;
      const fun = () => {
        if (curr >= paths.length) {
          this.loading = false;
          this.compress = '';
          clearInterval(interval);
          // this.$router.go(0);
          return;
        }
        curr++;
        this.compress = '后台压缩中 ' + ((curr / paths.length) * 100).toFixed(2) + '%';
      };
      let interval = setInterval(fun, 200);
      taskApi.preprocessUpload({id, name: dir.name, stagingFile: paths}).then(res => {
        if (res.code === 10000) {
          if (curr < paths.length) {
            clearInterval(interval);
            interval = setInterval(fun, 5);
          }
          console.log(res);
        }
      }).catch(() => {
      });
    },
    // 重建文件
    onRebuildingSuccess({paths}) {
      const path = R.head(paths);
      const {id} = this.params;
      this.form.rebuildingFile = path;
      taskApi.preprocessUpload({id, rebuildingFile: path});
    },
    // 归档文件
    onArchiveDelected({path}) {
      const {id} = this.params;
      this.form.archiveFile = null;
      taskApi.removeProcessFile({id, archiveFile: [path]});
    },
    onArchiveSuccess({paths}) {
      // const path = R.head(paths);
      // this.form.archiveFile = path;
      this.form.archiveFile = paths;
      this.$message.success('上传成功,请点击保存');
    },

    // 医生端文件
    onDoctorDelected({path}) {
      const {id} = this.params;
      this.form.doctorFile = null;
      taskApi.removeProcessFile({id, doctorFile: [path]});
    },
    onDoctorSuccess({paths}) {
      // const path = R.head(paths);
      // this.form.doctorFile = path;
      this.form.doctorFile = paths;
      this.$message.success('上传成功,请点击保存');
    },
    // 阅片软件
    onViewerAppDelected({path}) {
      const {id} = this.params;
      this.form.viewerAppFile = null;
      taskApi.removeProcessFile({id, viewerAppFile: [path]});
    },
    onViewerAppSuccess({paths}) {
      this.form.viewerAppFile = paths;
      this.$message.success('上传成功,请点击保存');
    },
    // 患者端文件
    async onPatientDelected() {
      const {id} = this.params;
      const data = await taskApi.removeProcessFile({id, patientFile: this.form.patientFile});
      if (data.code === 10000) {
        tip.success('删除成功');
      }
    },
    onPatientSuccess({dir, paths}) {
      const {id} = this.params;
      this.form.patientFile = dir.name;
      const loading = Loading.service({});
      taskApi.modelUpload({id, name: dir.name, model: paths}).then(res => {
        loading.close();
        this.$confirm('建议立即查看3D视图,确认模型和切缘正确', '检查3D', {
          confirmButtonText: '查看',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.onViewQrcode();
        });
      }).catch(() => {
        loading.close();
      });
    },
    // 三维影像报告
    onModeSuccess({paths}) {
      const path = R.head(paths);
      this.form.modelReportFile = path;
      this.$message.success('上传成功,请点击保存');
    },
    /**
     * 加载 重建类型 数据
     */
    async loadReconData() {
      const recon = await taskApi.reconData() || {};
      if (recon.code === 10000) {
        if (!this.form.reconIds) {
          return;
        }
        for (let i = 0; i < this.reconData.length; i++) {
          this.reconData[i].showInput = false;
          this.reconData[i].inputText = '';
        }
        recon.data.forEach(item => {
          // 先处理一级
          if (this.form.reconIds.search(item.id) !== -1) {
            item.check = true;
          }
          // 再处理二级
          item.children.forEach(child => {
            child.showInput = false;
            child.inputText = '';
            if (this.form.reconIds.search(child.id) !== -1) {
              child.check = true;
            }
            if (this.form.reconIds.search(child.id + ':') !== -1) {
              child.showInput = true;
              child.inputText = this.form.reconIds.split(child.id + ':')[1].split(',')[0];
            }
          });
        });
        this.reconData = recon.data;
      }
    },
    // 重建类型 change
    changeCheck(id, level) {
      this.reconData.forEach(item => {
        if (item.id === id && level === 1) {
          item.children.forEach(child => {
            if (child.def) child.check = item.check;
          });
        }
        if (item.id === id && level === 2) {
          let allDefCount = 0;
          let checkDefCount = 0;
          item.children.forEach(child => {
            if (child.def) allDefCount += 1;
            if (child.def && child.check) checkDefCount += 1;
            item.check = allDefCount > 0 && allDefCount === checkDefCount;
            if (child.name === '模拟肝切除') {
              child.showInput = child.check;
              // child.inputText = '';
            }
          });
        }
      });
    },
    /**
     * 加载 资料完整性
     */
    loadMaterialData() {
      if (this.form.materialIds) {
        this.materialData.forEach(item => {
          if (this.form.materialIds.search(item.id + ',') !== -1 || this.form.materialIds.search(item.id + ':') !== -1) {
            this.materialDataChecked.push(item.id);
            item.check = true;

            if (item.id === 9) {
              let materialFeedback = this.form.materialIds.split(':');
              if (materialFeedback && materialFeedback.length > 1) {
                this.materialFeedback = materialFeedback[1].split(',')[0];
                this.materialFeedbackShow = true;
              }
            }
          }
        });
      }
    },
    materialChange(item) {
      // 反馈
      if (item.id === 9) {
        this.materialFeedbackShow = !this.materialFeedbackShow;
      }
      if (!this.materialFeedbackShow) {
        this.materialFeedback = '';
      }
    },
    /**
     * 加载 病种
     */
    async loadDiseaseData() {
      const disease = await taskApi.diseaseData() || {};
      if (disease.code === 10000) {
        this.diseaseData = disease.data;
        this.diseaseData.forEach(item => {
          this.diseaseLevelOne.push(item);
          item.children.push({
            id: item.id + 99,
            name: '其他',
            level: 2
          });
          // 先处理一级
          if (this.form.diseaseIds && (this.form.diseaseIds.search(item.id + ',') !== -1 || this.form.diseaseIds.search(item.id + ':') !== -1)) {
            this.diseaseLevelOneId = item.id;
            // 再处理二级
            item.children.forEach(child => {
              this.diseaseLevelTwo.push(child);
              if (this.form.diseaseIds && (this.form.diseaseIds.search(child.id + ',') !== -1 || this.form.diseaseIds.search(child.id + ':') !== -1)) {
                child.check = true;
                this.diseaseLevelTwoDataChecked.push(child.id);
                if (child.id === item.id + 99) {
                  let diseaseOther = this.form.diseaseIds.split(':');
                  if (diseaseOther && diseaseOther.length > 1) {
                    this.diseaseOther = diseaseOther[1].split(',')[0];
                    this.diseaseOtherShow = true;
                  }
                }
              }
            });
          }
        });
      }
    },
    // 病种 下拉框 事件
    diseaseLevelOneChange() {
      this.diseaseData.forEach(item => {
        if (this.diseaseLevelOneId === item.id) {
          this.diseaseLevelTwo = item.children.slice();
        }
        this.diseaseLevelTwoDataChecked.length = 0;
        this.diseaseOther = '';
        this.diseaseOtherShow = false;
      });
    },
    // 病种 checkbox 事件
    diseaseLevelTwoChange(item) {
      if (item.id % 100 === 99) {
        this.diseaseOtherShow = !this.diseaseOtherShow;
      }
      if (!this.diseaseOtherShow) {
        this.diseaseOther = '';
      }
    },
    /**
     * 下载二维码
     */
    saveQrImg() {
      const {code} = this.form;
      const canvas = document.getElementById('qrcodeDown');
      const a = document.createElement('a');
      // a.href = canvasData[0].src;
      a.href = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
      a.download = code + '模型二维码.png';
      a.click();
    },
    // 退款
    async onRefund() {
      if (this.form.payStatus !== 1) {
        this.$message.warning('订单状态非支付成功！');
        return;
      }
      if (this.form.priceSum <= 0) {
        this.$message.warning('订单需大于0');
        return;
      }
      if (!this.refundForm.verify) {
        return this.$message.warning('请输入安全密码');
      }
      if (!this.refundForm.remark) {
        return this.$message.warning('请输入退款原因');
      }
      if (!this.refundForm.optName) {
        return this.$message.warning('请输入操作人姓名');
      }
      this.refundForm.orderId = this.form.orderId;

      const res = await refundApi.refund(this.refundForm);
      if (res.code === 10000) {
        this.dialogRefund = false;
        this.$message.success('退款提交成功，处理结果请查看退款记录！');
      } else {
        this.$message.error(res.msg);
      }
    },
    // 添加订单标签
    addTaskTag(newTag) {
      if (this.form.tags && this.form.tags.indexOf(newTag) < 0) {
        this.form.tags += '|' + newTag;
      } else {
        this.form.tags = newTag;
      }
      this.setTaskTags(this.form.tags);
    },
    // 删除订单标签
    delTaskTag(tag) {
      this.$confirm('删除订单标签:' + tag, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.form.tags) {
          this.form.tags = this.form.tags.split('|').filter(t => t !== tag).join('|');
        }
        this.setTaskTags(this.form.tags);
      });
    },
    async setTaskTags(tags) {
      const data = await taskApi.setTaskTags(this.form.id, tags);
      if (data.code === 10000) { tip.success('保存成功!'); }
    },
    // 加载工序任务分配清单
    fetchTaskAndWorkers() {
      const {id} = this.$route.params;
      scorepoint.getWorkers().then(res => {
        if (res.code === 10000) {
          this.allWorkers = [];
          res.data.forEach(worker => {
            this.allWorkers.push({id: worker.id, name: worker.username});
          });
        }
        return scorepoint.getActionAndUsers(id);
      }).then(res => {
        if (res.code === 10000) {
          this.isMyTask = false;
          this.allActionTemplates = [];
          this.activeActionTemplatesName = null;
          this.activeActionTemplate = null;
          for (let seq of res.data) {
            this.allActionTemplates.push({taskType: seq[0].taskType, actions: seq});
            for (let act of seq) {
              if (act.ownerId != null) {
                this.activeActionTemplate = this.allActionTemplates[this.allActionTemplates.length - 1];
                this.isMyTask = this.isMyTask || (act.ownerId === this.userInfo.id);
              }
            }
          }
          if (this.activeActionTemplate) {
            this.activeActionTemplatesName = this.activeActionTemplate.taskType;
          }
        }
      });
    },
    // 改变工序的负责人
    changeActionOwnerAll(workerId) {
      if (this.activeActionTemplate && this.activeActionTemplate.actions) {
        for (let act of this.activeActionTemplate.actions) {
          act.ownerId = workerId;
        }
        this.changeActionOwner();
      }
    },
    changeActionOwner() {
      const {id} = this.$route.params;
      console.info(this.activeActionTemplate.actions);
      scorepoint.assignUser(id, this.activeActionTemplate.actions).then(res => {
        if (res.code === 10000) {
          if (this.form.status === 3) {
            this.$message.error('绩点已结算,修改人员并不会重新结算绩点!');
          } else {
            this.$message.success('提交成功');
          }
        }
      });
    },
    // 查询订单操作记录
    fetchTaskActivities() {
      const {id} = this.$route.params;
      task.getActivities(id).then(res => {
        if (res.code === 10000) {
          this.taskActivities = res.data;
          this.taskActivities.forEach(item => {
            // console.error(item);
            var date = new Date(Date.parse(item.createTime));
            item.createTime = date.toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
          });
        }
      });
    },
    // 合并订单
    mergeOrder(srcTaskId) {
      this.$prompt('请输入安全密码', '安全密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (val) => { if (!val) return '安全密码为必填'; },
        inputPattern: /^.+$/,
        inputErrorMessage: '安全密码为必填'
      }).then((result) => {
        let veifyCode = result.value;
        this.$prompt('删除请输入[删除],如需合并到其他订单,请输入订单号', '删除当前订单', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputValidator: (val) => { if (!val) return '订单号为必填'; },
          inputPattern: /^.+$/,
          inputErrorMessage: '输入要并入的订单号;如果要删除订单,请输入[删除]'
        }).then(async({value}) => {
          const data = await taskApi.mergeTask(srcTaskId, value, veifyCode);
          if (data.code === 10000) {
            tip.success('合并成功!');
          }
        });
      });
    },
    // 代理商扣款
    agentPay(srcTaskId) {
      this.$prompt('请输入财务密码', '财务密码(代理商扣款)', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (val) => { if (!val) return '密码为必填'; },
        inputPattern: /^.+$/,
        inputErrorMessage: '密码为必填'
      }).then(async(result) => {
        let veifyCode = result.value;
        const data = await taskApi.agentPay(srcTaskId, veifyCode);
        if (data.code === 10000) {
          tip.success('成功!');
          this.onCreated();
        }
      });
    },
    // 代理商退款
    agentRefund(srcTaskId) {
      this.$prompt('请输入财务密码', '财务密码(退款)', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (val) => { if (!val) return '密码为必填'; },
        inputPattern: /^.+$/,
        inputErrorMessage: '密码为必填'
      }).then(async(result) => {
        let veifyCode = result.value;
        const data = await taskApi.agentRefund(srcTaskId, veifyCode);
        if (data.code === 10000) {
          tip.success('成功!');
          this.onCreated();
        }
      });
    },
    // 等待生成AppViewer
    waitForAppViewer() {
      let that = this;
      const {id} = this.$route.params;
      this.waitAppViewer = true;
      this.$refs.viewerAppUpload.setFile({paths: ['']});
      let fetchFunction = null;
      fetchFunction = () => {
        taskApi.fetchById(id).then((data) => {
          if (data.code === 10000 && data.data && data.data.viewerAppFile.length > 0 && data.data.viewerAppFile[0].length > 0) {
            that.$refs.viewerAppUpload.setFile({paths: data.data.viewerAppFile});
            that.waitAppViewer = false;
            this.$message({message: '阅片程序生成成功!', duration: 5000});
          } else if (this.waitAppViewer) {
            setTimeout(fetchFunction, 10000);
          }
        });
      };
      fetchFunction();
    }
  },
  mounted() {
    this.onCreated();
    this.fetchTaskAndWorkers();
  },
  watch: {
    activeActionTemplatesName(val) { // 切换工序模板
      for (let at of this.allActionTemplates) {
        if (at.taskType === val) {
          this.activeActionTemplate = at;
        }
      }
    },
    activeTab(val) { // 切换tab
      // console.log(val);
      if (val === 'tab3') {
        this.fetchTaskActivities();
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepCache = this.keepCache;
    next();
  }
};
</script>
<style lang="scss">
.stl-add {

  .el-tag.el-tag--info {
    color: white;
  }

  .el-select .el-tag {
    background-color: #222933;
  }
}
</style>
<style lang="scss" scoped>

.btn-container {
  padding-bottom: 10px;
}

.line {
  width: 100%;
  background: #9FB6E2;
  opacity: 0.5;
  height: 0.5px;
  margin: 0 10px 20px;
}

.qrcode {
  position: absolute;
  right: 68px;
  top: 32px;
  text-align: center;

  .text {
    font-size: 16px;
  }
}

.content {
  word-wrap: break-word;
}

.mockData {
  /deep/ .el-table .el-table_1_column_2 .cell {
    padding-left: 0;

    .el-checkbox {
      margin: 10px;
      width: 200px;
    }

    .addition {
      float: left;
      margin: 10px;
      width: 200px;
    }
  }

  .el-checkbox {
    margin: 10px;
    width: 200px;
  }
}

.checkbox {
  margin: 10px;
  width: 200px;
}

.back-button {
  position: fixed;
  top: 16px;
  left: 200px;
  background-color: rgba(221, 236, 255, 0.1);
  border: none;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  padding: 0;
  background-image: url('~@/assets/backto.png');
}
</style>



// WEBPACK FOOTER //
// src/view/OrderView/index.vue